var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofencesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 33.3337C29.1547 33.3337 33.3334 29.155 33.3334 24.0003C33.3334 18.8457 29.1547 14.667 24.0001 14.667C18.8454 14.667 14.6667 18.8457 14.6667 24.0003C14.6667 29.155 18.8454 33.3337 24.0001 33.3337Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z",
    stroke: "#CC0000",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 25.3337C24.7365 25.3337 25.3334 24.7367 25.3334 24.0003C25.3334 23.2639 24.7365 22.667 24.0001 22.667C23.2637 22.667 22.6667 23.2639 22.6667 24.0003C22.6667 24.7367 23.2637 25.3337 24.0001 25.3337Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofencesActive);
export default __webpack_public_path__ + "static/media/geofences-active.4914f7d187f62c0e89ce781da1231828.svg";
export { ForwardRef as ReactComponent };